import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "share-planner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_SharePlannerModal = _resolveComponent("SharePlannerModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PxButton, _mergeProps({ class: "share-planner__toggler" }, _ctx.shareButtonProps, {
      onClick: _withModifiers(_ctx.openShareModalClickHandler, ["stop"])
    }), null, 16, ["onClick"]),
    _createVNode(_component_SharePlannerModal, {
      visibility: _ctx.shareModalVisible,
      "onUpdate:visibility": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shareModalVisible) = $event)),
      passcode: _ctx.plannerPasscode,
      uid: _ctx.milestonePlanner.uid,
      users: _ctx.allInvitedUsers
    }, null, 8, ["visibility", "passcode", "uid", "users"])
  ]))
}